// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fN-z","hovered":"gN-z","hoverImage":"hN-z","mainImage":"iN-z","imageNoBackground":"jN-z","fullSizeImage":"kN-z"};